import React, { Component } from 'react';
import ReactSlider from 'react-slider'
import {isMobile } from 'react-device-detect';

class RCSlider extends Component {
  constructor(props) {
    super();
    this.onSliderChange = this.onSliderChange.bind(this);
  }

  onSliderChange (value) {
    if(this.props.type === "large"){
      this.props.setLargeFontSize(value);
      this.props.setLargeFontSizeUpdated(true);
    }

    if(this.props.type === "small"){
      this.props.setSmallFontSize(value);
      this.props.setSmallFontSizeUpdated(true);
    }
  }

 
  getMinValueForSlider(){
    if (this.props.type === 'large'){
      if (isMobile){
        return 32
      }
      else{
        return 40
      }
    }else{
      if (isMobile){
        return 16
      }else{
        return 12
      }
    }
  }
  getMaxValueForSlider(){
    if (this.props.type === 'large'){
      if (isMobile){
        return 48
      }
      else{
        return 110
      }
    }else{
      if (isMobile){
        return 24
      }else{
        return 22
      }
    }
  }

  render() {
    return (
      <ReactSlider
        className={`rc-slider ${this.props.orientation === 'vertical' ? 'rc-slider-vertical' : 'rc-slider-horizontal'}`}
        min={this.getMinValueForSlider() /*this.props.type === 'large' ? 40 : 12*/}
        max={this.getMaxValueForSlider() /*this.props.type === 'large' ? 110 : 22 */}
        onChange={this.onSliderChange}
        value={this.props.value}
        thumbClassName="rc-slider-handle"
        trackClassName="rc-slider-track"
        orientation={this.props.orientation || 'horizontal'}
        invert={this.props.orientation === 'vertical' ? true: false}
      />
    );
  }
}

export default RCSlider;
